import moment from "moment";
import { IFoundedAuctions } from "../../interfaces/IfoundedAuctions";
const AuctionsByRegionAndZip = ({
  foundedAuctions,
}: {
  foundedAuctions: IFoundedAuctions;
}) => {
  return (
    <div className="p-4">
      <h1 className="text-2xl text-bold">{foundedAuctions.title}</h1>
      <span className="text-gray-500">
        {moment(foundedAuctions.date).format("ddd, MM Do YYYY")} &nbsp;
        {foundedAuctions.time}
      </span>
      <br />
      <span className="text-gray-700">
        {foundedAuctions.address},{foundedAuctions.city} ,
        {foundedAuctions.state}, {foundedAuctions.zip}
      </span>
      <br />
      <span className="text-gray-700">{foundedAuctions.company_name}</span>
      <br />
      <label className="mt-4">Description:</label>
      <br />
      <p className="mt-4">{foundedAuctions.description}</p>
    </div>
  );
};

export default AuctionsByRegionAndZip;
